import React from "react";
import { useEffect, useState } from "react";
import Spinner from "../../components/base/Spinner";
import OrganisationLayout from "../../components/organisation/layout/OrganisationLayout";
import CustomerDetails from "../../components/organisation/CustomerDetails";

const CustomerDetailsIndex = () => {
    const [loading, setLoading] = useState(false);
    const [open, setInviteModalOpen] = useState(false);

    const openModal = () => {
        setInviteModalOpen(true);
    };

    return (
        <OrganisationLayout>
            {loading ? (
                <Spinner spinnerText="" styles="" />
            ) : (
                <>
                    <div>
                        <CustomerDetails />
                    </div>
                </>
            )}
        </OrganisationLayout>
    );
};

export default CustomerDetailsIndex;
